import type { ViewjobQuery } from '../../../../__generated__/viewjob.gqlgenerated';

export const isHiringEvent = (viewJobData: NonNullable<ViewjobQuery['viewjob']> | undefined) => {
    return viewJobData?.details?.applyMethod?.__typename === 'ViewJobHiringEvent';
};
